import { UnexpectedError } from 'utils/errors';
import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  idUser: number;
};

export const dropUserPartner = async (params: Params) => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('dropUserPartner'), {
    method: 'DELETE',
    body,
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
